import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import HeaderDashboard from "../../Components/HeaderDashboard";
import { CancelBookedPolicy } from '../../Services/InsuranceApi'
import { GetTransactionDetails } from "../../Services/InsuranceApi";


const InsCancellationBooking = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const queryParams = new URLSearchParams(location.search);
  function getParamIgnoreCase(key) {
    for (const [k, v] of queryParams.entries()) {
      if (k.toLowerCase() === key.toLowerCase()) {
        return v;
      }
    }
    return null;
  }
  const referenceNo = getParamIgnoreCase("ReferenceNo");
  const key = getParamIgnoreCase("Key");
  const clientCode = getParamIgnoreCase("ClientCode");

  const [cancelReasons, setCancelReasons] = useState([
    {
      "id": "b1c6dcfb-d52c-4579-8e05-0f63c57f7e10",
      "name": "Change in travel dates post policy commencement"
    },
    {
      "id": "b1c6dcfb-d52c-4579-8e05-0f63c57f7e11",
      "name": "Wrong issuance"
    },
    {
      "id": "b1c6dcfb-d52c-4579-8e05-0f63c57f7e12",
      "name": "Change in travel plan post policy commencement "
    },
    {
      "id": "b1c6dcfb-d52c-4579-8e05-0f63c57f7e13",
      "name": "Policy active with other insurer"
    },
    {
      "id": "b1c6dcfb-d52c-4579-8e05-0f63c57f7e14",
      "name": "Trip cancelled by customer"
    },
    {
      "id": "b1c6dcfb-d52c-4579-8e05-0f63c57f7e15",
      "name": "Duplicate policy issued"
    },
    {
      "id": "b1c6dcfb-d52c-4579-8e05-0f63c57f7e16",
      "name": "Visa not approved"
    },
    {
      "id": "b1c6dcfb-d52c-4579-8e05-0f63c57f7e17",
      "name": "Change in geography post policy commencement"
    },
    {
      "id": "b1c6dcfb-d52c-4579-8e05-0f63c57f7e18",
      "name": "E - commerce cancellation "
    },
    {
      "id": "b1c6dcfb-d52c-4579-8e05-0f63c57f7e19",
      "name": "Default e-commerce cancellation"
    }
  ]);

  const userName =
    localStorage.getItem("userName") || "";


  const [selectedPassengers, setSelectedPassengers] = useState([]);
  const [cancelReason, setCancelReason] = useState("");
  const [comments, setComments] = useState("");

  // const handlePassengerSelect = (index) => {
  //   setSelectedPassengers((prev) =>
  //     prev.includes(index)
  //       ? prev.filter((i) => i !== index)
  //       : [...prev, index]
  //   );
  // };
  const handlePassengerSelect = (pax) => {
    setSelectedPassengers((prev) =>
      prev.some((p) => p.policyNo === pax.policyNo)
        ? prev.filter((p) => p.policyNo !== pax.policyNo)
        : [...prev, pax]
    );
  };



  const [transactionData, setTransactionData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [cancelLoading, setCancelLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [showCancellationPopup, setShowCancellationPopup] = useState(false);
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const [showFailPopup, setShowFailPopup] = useState(false);

  useEffect(() => {

    const fetchTransactionDetails = async () => {
      try {
        const params = {
          ReferenceNo: referenceNo,
          Key: key,
          ClientCode: clientCode,
        };

        const response = await GetTransactionDetails(params);
        //console.log("Transaction Details =>", response);
        setTransactionData(response);

      } catch (error) {
      } finally {
        setLoading(false);
      }
    };

    if (referenceNo) {
      fetchTransactionDetails();
    } else {
      console.warn("Missing referenceNo");
      setLoading(false);
    }

  }, [referenceNo]);



  const booking =
    transactionData?.booking;

  const passengers =
    transactionData?.passengers || [];

  const payments =
    transactionData?.payments || [];

  const rider =
    transactionData?.rider || [];

  const formatDate = (dateStr) => {
    if (!dateStr) return "";

    return new Date(dateStr).toLocaleDateString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };

  const formatTime = (dateStr) => {
    if (!dateStr) return "";

    return new Date(dateStr).toLocaleTimeString("en-IN", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  };



  const handleCancelPolicy = async () => {
    let newErrors = {};

    // Validation
    if (!selectedPassengers.length) {
      newErrors.selectedPassengers =
        "Please select at least one passenger";
    }

    if (!cancelReason) {
      newErrors.cancelReason =
        "Please select cancellation reason";
    }

    if (
      cancelReason === "Other" &&
      !comments?.trim()
    ) {
      newErrors.comments =
        "Please enter comments";
    }

    setErrors(newErrors);

    if (Object.keys(newErrors).length > 0) {
      return;
    }

    setShowCancellationPopup(true);
  }


  const CancelledMyBooking = async () => {
    try {
      setCancelLoading(true);

      const requestBody = {
        key,
        clientCode,
        userName,
        referenceNo: transactionData.referenceNo,
        cancellationCharge: 0,
        //policyNumber: booking?.policyNumber || "",
        cancellationReason: cancelReason,
        remark: comments || "",
        traveler: selectedPassengers
        //orderId: booking?.orderId || "",
      };

      //console.log("REQUEST BODY", requestBody);
      const response = await CancelBookedPolicy(requestBody);
      //console.log("Cancellation Response", response);

      if (response?.results?.[0]?.status === "Success" && response?.success === true) {
        setSuccess(response?.message || "Policy cancelled successfully.");
        setShowCancellationPopup(false);
        setShowSuccessPopup(true);
        setError("");
      } else {
        setError( response?.message || "Cancellation failed." );
         setSuccess( response?.results?.[0]?.errorMessage|| "Policy Cancellation failed.");
        setShowCancellationPopup(false);
        setShowFailPopup(true);
      }
    } catch (error) {
      console.error(
        "Cancellation Error:",
        error
      );

      setError(
        error?.response?.data
          ?.message ||
        error?.message ||
        "Unable to cancel policy."
      );
    } finally {
      setCancelLoading(false);
    }
  };

  const GOTODEtailsPage = () => {
    setShowSuccessPopup(false);
    setTimeout(() => {
      navigate(
        `/reservations/insurance/TransactionsDetails?referenceNo=${referenceNo}&clientCode=${clientCode}&key=${key}`
      );
    });
  }

  return (
    <>
      {loading && (
        <p class="text-center load"><span class="loader"></span></p>
      )}
      {cancelLoading && (
        <p class="text-center load"><span class="loader"></span></p>
      )}
      <HeaderDashboard />
      <div className="toolbar py-2" id="kt_toolbar">
        <div id="kt_toolbar_container" className="container-fluid d-flex align-items-center">
          <div className="flex-grow-1 flex-shrink-0 me-5">
            <div data-kt-swapper="true" data-kt-swapper-mode="prepend" data-kt-swapper-parent="{default: '#kt_content_container', 'lg': '#kt_toolbar_container'}" className="page-title d-flex align-items-center flex-wrap me-3 mb-5 mb-lg-0">
              <h1 className="d-flex align-items-center text-gray-900 fw-bold my-1 fs-3">Reservations</h1>
              <span className="h-20px border-gray-200 border-start mx-3"></span>
              <ul class="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-1">
                <li class="breadcrumb-item text-muted">Insurance</li>
                <li class="breadcrumb-item">
                  <span class="bullet bg-gray-200 w-5px h-2px"></span>
                </li>

                <li class="breadcrumb-item text-gray-900">Cancellation Booking</li>
              </ul>
            </div>
          </div>
          <div class="d-flex align-items-center flex-wrap">
            <div class="flex-shrink-0 me-2 d-none-mob">
              <ul class="nav" role="tablist">
                <li class="nav-item" role="presentation">
                  <a href="#" onClick={(e) => { e.preventDefault(); window.history.back(); }} >
                    <img src="/assets/images/back.png" width={30} />
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <section className="wraper">
        <div className="box_shadow mt-14">
          <div className="row">
            <div className='col-md-12 col-lg-12'>
              <h6 class="ruler">Booking Details</h6>
              <table className="table table-bordered responsive-table">
                <thead>
                  <tr>
                    <th>Reference No</th>
                    <th>Policy No</th>
                    <th>Policy Status</th>
                    <th>Start Date</th>
                    <th>End Date</th>
                  </tr>
                </thead>

                <tbody>
                  <tr>
                    <td>{booking?.referenceNo}</td>
                    <td>{booking?.policyNumber}</td>
                    <td>
                      <span style={{ color: "green" }}>
                        <b>{booking?.bookingStatus}</b>
                      </span>
                    </td>
                    <td>{booking?.startDate}</td>
                    <td>{booking?.endDate}</td>
                  </tr>
                </tbody>

              </table>
            </div>

            <div className='col-md-12 col-lg-12'>
              <h6 className='ruler'>Policy Details</h6>
              <div className='table-responsive'>
                <table className="table table-bordered responsive-table">
                  <thead>
                    <tr>
                      <th>policyNo</th>
                      <th>Insurer Name</th>
                      <th>Total Premium</th>
                      <th>Start Date</th>
                      <th>End Date</th>
                      <th>Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>{booking?.policyNumber}</td>
                      <td>{booking?.insuranceName}</td>
                      <th> <i class="fa fa-inr"></i> {booking?.totalPremium}</th>
                      <td>{booking?.startDate}</td>
                      <td>{booking?.endDate}</td>
                      <td>{booking?.bookingStatus}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div className='col-md-12 col-lg-12'>
              <h6 className='ruler'>Passenger Policy Details</h6>
              <div className='table-responsive'>
                <table className="table table-bordered responsive-table">
                  <thead>
                    <tr>
                      <th>Cancel Policy</th>
                      {/* <th>Premium</th> */}
                      <th>Name</th>
                      <th>Age</th>
                      <th>Email</th>
                      <th>Mobile</th>
                      <th>Nominee</th>
                      <th>Relation</th>
                      <th>Address</th>
                    </tr>
                  </thead>
                  <tbody>
                    {passengers?.length > 0 ? (
                      passengers.map((pax, index) => (
                        <tr key={index}>
                          <td>
                            <input
                              className="checkBox mx-2"
                              type="checkbox"
                              checked={selectedPassengers.some(
                                (p) => p.policyNo === pax.policyNo
                              )}
                              onChange={() => handlePassengerSelect(pax)}
                            />
                            {pax?.policyNo}
                          </td>

                          {/* <td>
                            <i className="fa fa-inr"></i>{" "}
                            {pax?.finalPremium ||
                              booking?.totalPremium ||
                              0}
                          </td> */}

                          <td>
                            {pax?.title} {pax?.firstName}{" "}
                            {pax?.lastName}
                          </td>

                          <td>{pax?.age}</td>

                          <td>{pax?.email}</td>

                          <td>{pax?.mobileNo}</td>

                          <td>{pax?.nominee}</td>

                          <td>{pax?.relation}</td>

                          <td>{pax?.address}</td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td
                          colSpan="9"
                          className="text-center"
                        >
                          No Passengers Found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
              {errors.selectedPassengers && (
                <div className="text-danger mb-2">
                  {errors.selectedPassengers}
                </div>
              )}
            </div>
            {/* Cancellation Reason */}
            <div className="col-md-12 mb-3 remrk">
              <h6 className="ruler">
                Cancellation Reason <span className="required"></span>
              </h6>

              {cancelReasons.map((reason) => (
                <div className="form-check mt-2" key={reason.id}>
                  <input
                    type="radio"
                    className="form-check-input"
                    id={`cancelReason-${reason.id}`}
                    name="cancelReason"
                    value={reason.id}
                    checked={cancelReason === reason.id}
                    onChange={(e) => setCancelReason(e.target.value)}
                  />

                  <label
                    className="form-check-label"
                    htmlFor={`cancelReason-${reason.id}`}
                  >
                    {reason.name}
                  </label>
                </div>
              ))}

              {errors.cancelReason && (
                <div className="text-danger mt-1">
                  {errors.cancelReason}
                </div>
              )}
            </div>

            {/* <div className="col-md-12">
              <div className="form_row">
                <label className="required">Cancellation Reason</label>
                <select
                  className="form-control"
                  value={cancelReason}
                  onChange={(e) => setCancelReason(e.target.value)}
                >
                  <option value="">-- Select Reason --</option>
                  <option value="">Text</option>
                </select>
              </div>

              {errors.cancelReason && (
                <div className="text-danger mt-1">
                  {errors.cancelReason}
                </div>
              )}
            </div> */}

            {/* Comments */}
            <div className="col-md-12 mt-3">
              <label>Write Comments</label>
              <textarea
                className="form-controls"
                rows="3"
                value={comments}
                onChange={(e) =>
                  setComments(e.target.value)
                } placeholder="Write Comments..."
              />
              {errors.comments && (
                <div className="text-danger mt-1">
                  {errors.comments}
                </div>
              )}
            </div>

            {/* Submit */}
            <div className="col-md-12 mt-4 text-end">
              <button
                type="button"
                className="btn btn-primary"
                onClick={handleCancelPolicy}
                disabled={loading}
              >
                {loading
                  ? "Cancelling..."
                  : "Cancel Policy"}
              </button>
            </div>



          </div>
        </div>
      </section>

      {showCancellationPopup && (
        <div
          className="modal fade show"
          style={{
            display: "block",
            backgroundColor: "rgba(0,0,0,0.5)"
          }}
        >
          {loading && (
            <p class="text-center load"><span class="loader"></span></p>
          )}
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">

              <div className="modal-header">
                <h5 className="modal-title">
                  Cancellation Details
                </h5>

                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowCancellationPopup(false)}
                ></button>
              </div>

              <div className="modal-body">
                <div className="text-danger fw-bold mt-3">
                  Are you sure you want to cancel this ticket?
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => setShowCancellationPopup(false)}
                >
                  Close
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={CancelledMyBooking}
                  disabled={loading}
                >
                  {loading ? "Cancelling..." : "Cancel Ticket"}
                </button>

              </div>

            </div>
          </div>
        </div>
      )}

      {showSuccessPopup && (
        <div
          className="modal fade show"
          style={{
            display: "block",
            backgroundColor: "rgba(0,0,0,0.5)"
          }}
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">

              <div className="modal-header">
                <h5 className="modal-title text-success">
                  Cancellation Successful
                </h5>

                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowSuccessPopup(false)}
                ></button>
              </div>

              <div className="modal-body text-center">
                <div className="text-success mb-3">
                  <i className="fa fa-check-circle fa-3x"></i>
                </div>

                <h5 className="text-success">
                  {success}
                </h5>

                <p className="text-muted mb-0">
                  Your ticket has been cancelled successfully.
                </p>
              </div>

              <div className="modal-footer justify-content-center">
                <button
                  type="button"
                  className="btn btn-success"
                  // onClick={() => setShowSuccessPopup(false)}
                  onClick={GOTODEtailsPage}
                >
                  OK
                </button>
              </div>

            </div>
          </div>
        </div>
      )}

      {showFailPopup && (
        <div
          className="modal fade show"
          style={{
            display: "block",
            backgroundColor: "rgba(0,0,0,0.5)"
          }}
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">

              <div className="modal-header">
                <h5 className="modal-title text-danger">
                  Cancellation failure
                </h5>

                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowFailPopup(false)}
                ></button>
              </div>

              <div className="modal-body text-center">
                <div className="text-danger mb-3">
                  <i className="fa fa-times-circle fa-3x text-danger"></i>
                </div>

                <h5 className="text-danger">
                  {success}
                </h5>

                <p className="text-muted mb-0">
                  An error occurred while processing the cancellation request.
                </p>
              </div>

              <div className="modal-footer justify-content-center">
                <button
                  type="button"
                  className="btn btn-danger"
                  onClick={() => setShowFailPopup(false)}
                >
                  OK
                </button>
              </div>

            </div>
          </div>
        </div>
      )}
    </>

  );

};
export default InsCancellationBooking;